import React, { FC, Fragment } from "react";
import { connect } from "react-redux";
import { matchPath } from "react-router-dom";

import { Pojo, AppGalaxyInfo } from "types/Galaxy";
import { ReducerState } from "reducers";

import { findMap } from "utils/entities.utils";
import { selectCurrentEntity, selectGalaxyInformation } from "selectors";
import { Location } from "react-router-dom";

interface LabelGalaxyProps {
  galaxies: Record<string, AppGalaxyInfo>;
  location: Location;
}

interface LabelGalaxyReduxProps {
  currentEntity?: Pojo;
  code?: string;
}

type LabelGalaxyAllProps = LabelGalaxyProps & LabelGalaxyReduxProps;

const LabelGalaxy: FC<LabelGalaxyAllProps> = ({ galaxies, code, currentEntity }) => {
  if (code) {
    const currentGalaxy = findMap(galaxies, galaxy => galaxy.code === code);

    const entityString = currentEntity ? currentEntity.label : "";

    return currentGalaxy !== null ? (
      <Fragment>
        <h3 className="title is-5">{currentGalaxy.label}</h3>
        <title>
          {currentEntity
            ? `${currentGalaxy.label} : ${entityString}`
            : `Octal : ${currentGalaxy.label} : ${entityString}`}
        </title>
      </Fragment>
    ) : null;
  } else {
    return null;
  }
};

const mapStateToProps = (
  state: ReducerState,
  { location }: LabelGalaxyAllProps
): LabelGalaxyReduxProps => {
  const match = matchPath("/page/:code/*", location.pathname);
  const code = match ? match.params.code : undefined;
  const id = match ? match?.params["*"] : undefined;

  if (code) {
    const galaxyInfo = selectGalaxyInformation(state, code);

    const entity =
      galaxyInfo && id
        ? selectCurrentEntity(state, { sjmoCode: code, tableName: galaxyInfo.tableName, id })
        : undefined;

    return {
      code,
      currentEntity: entity
    };
  }
  return {};
};

export default connect<LabelGalaxyReduxProps>(mapStateToProps)(LabelGalaxy);
